﻿import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";
import * as moment from 'moment';

@Pipe({
    name: "formatDateTime"
})
export class FormatDateTimePipe implements PipeTransform {
    public transform(datetime: any, format: string): any {
        if (datetime == null) {
            return "";
        }

        if (!format) {
            format = "MM/DD/YYYY HH:mm";
        }

        if (typeof datetime === "string") {
            datetime = datetime.substring(0, 19);
            return moment(new Date(datetime.replace(/-/g, "\/").replace("T", " "))).format(format);
        } else {
            return moment(datetime).format(format);            
        }
    }
}
